import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Typography)`
  align-items: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: pre;
  display: block;

  &.capitalize {
    text-transform: capitalize;
  }

  &.hasLink {
    cursor: pointer;
    :hover {
      color: ${(p) => p.theme.palette.primary[500]};
      text-decoration: underline;
    }
  }
`;
